export class AgreeToPrivacyStatement {
  public static readonly type = '[Privacy statement] Agree to privacy statement';
}
